import { makeStyles } from '@material-ui/core';
import { Form } from 'formik';
import FormikTextField from 'components/FormikFields/FormikTextField';
import { useSelector } from 'react-redux';
import { FormattedPhone } from '../../../Shared/FormattedPhone';

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3),
    background: '#ffffff',
    borderRadius: 12,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
  },
  sectionTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: theme.colors?.blue2 || '#122056',
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    borderBottom: `2px solid ${theme.colors?.lightBlue || '#5B65DC'}`,
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));

const UserEditForm = ({ backendErrors }) => {
  const classes = useStyles();
  const { en: { forms } } = useSelector((state) => state.i18n);

  return (
    <Form>
      <div className={classes.section}>
        <div className={classes.sectionTitle}>
          {forms?.userDetails || 'User Information'}
        </div>
        <div className={classes.formContainer}>
          <FormikTextField
            type="text"
            name="firstName"
            label={forms?.firstName || 'First Name'}
            backendError={backendErrors.firstName}
            required
          />
          <FormikTextField
            type="text"
            name="lastName"
            label={forms?.lastName || 'Last Name'}
            backendError={backendErrors.lastName}
            required
          />
          <FormikTextField
            type="email"
            name="email"
            label={forms?.email || 'Email'}
            backendError={backendErrors.email}
            required
          />
          <FormikTextField
            type='tel'
            name='phone'
            label={forms.phone || 'Phone Number'}
            backendError={backendErrors.phone}
            placeholder="+1 (555) 123-4567"
            InputProps={{
              inputComponent: FormattedPhone,
            }}
            // required
          />
        </div>
      </div>
    </Form>
  );
};

export default UserEditForm;
